export default "__VITE_ASSET__Y9j2tYIN__"